import {
  formEncode,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const Employee = {
  createEmployee: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/create',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  EditEmployee: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/edit',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  sendPassword: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/send-password',
        formEncode(data)
      );
    } catch (error) {
      response = error;
    }
    return handleResponse(response);
  },
  DeleteEmployee: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/delete',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchEmployees: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/fetch',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  enableDisableEmployee: async (data: any) => {
    let response = null;
    try {
      response = await nextFormDataApi.post(
        '/employees/enable-disable',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default Employee;
